import React from "react";
import { useState, useEffect } from "react";
import {
  getDepartmentEmployeeAssetList,
  getDepartmentEmployeeAssetListExport,
} from "../../services/AssetService";
import { Spinner } from "react-bootstrap";
import Pagination from "../Constant/Pagination";
import { Offcanvas } from "react-bootstrap";
import { Link } from "react-router-dom";
import { AiFillProduct } from "react-icons/ai";
import { FaArrowAltCircleRight } from "react-icons/fa";
import { useSelector } from "react-redux";
import DebounceSearchInput from "../Constant/DebounceSearchInput";
import Select from "react-select";
import { CancelRequest } from "../../services/AxiosInstance";
import { getAllDepartments } from "../../services/SettingServices";
import DebounceSmallSearchInput from "../Constant/DebounceSmallSearchInput";
import GlobalSearchableDropdown from "../Constant/SearchableDropdown";
import { FaDownload } from "react-icons/fa";
import { toast } from "react-toastify";
const DepartmentEmployeeAsset = () => {
  const userRole = useSelector((state) => state.auth.user.role);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [exportLoading, setExportLoading] = useState(false);
  const [error, setError] = useState("");
  const [total, setToatl] = useState(0);
  const [departmentOption, setDepartmentOption] = useState([]);
  const [selectedDepartmet, setSelecetdDepartment] = useState(null);
  const [param, setParam] = useState({
    query: "",
    department: "",
    page: "1",
    page_size: "10",
  });
  const getEmployeeAssetList = () => {
    const { department, ...queryParam } = param;
    setLoading(true);
    getDepartmentEmployeeAssetList(userRole !== "HOD" ? param : queryParam)
      .then((res) => {
        setError("");
        setData(res?.data?.results || []);
        setToatl(res?.data?.count || 0);
      })
      .catch((err) => {
        setError(
          err?.response?.data?.message ||
            err?.response?.data?.error ||
            "Try again later"
        );
      })
      .finally(() => {
        setLoading(false);
      });
  };
  const getDepartment = () => {
    getAllDepartments()
      .then((res) => {
        const deptList = res?.data?.results || [];
        const options = deptList.map((item) => ({
          label: item?.name,
          value: item?.id,
        }));
        setDepartmentOption(options);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  useEffect(() => {
    if (userRole !== "HOD") {
      getDepartment();
    }
  }, []);
  useEffect(() => {
    getEmployeeAssetList();
  }, [param]);
  useEffect(() => {
    const newDepartment = selectedDepartmet?.value || "";
    if (param.department !== newDepartment) {
      setParam((prev) => ({ ...prev, department: newDepartment }));
    }
  }, [selectedDepartmet]);

  const handlePageChange = (page) => {
    setParam((prev) => ({
      ...prev,
      page: page.selected + 1,
    }));
  };

  const handleSearchChange = (value) => {
    if (value.length > 0) CancelRequest();
    setParam((prev) => ({
      ...prev,
      query: value,
      page: 1,
    }));
  };

  const handleExport = () => {
    setExportLoading(true);
    let exportParam = { ...param, export: true };

    if (userRole === "HOD") {
      const { department, ...rest } = param;
      exportParam = { ...rest, export: true };
    }
    getDepartmentEmployeeAssetListExport(exportParam)
      .then((res) => {
        const blob = new Blob([res.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });

        const url = window.URL.createObjectURL(blob);

        const a = document.createElement("a");
        a.href = url;
        a.download = "Employee-Asset.xlsx";

        // Append to DOM to make it more consistent
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);

        window.URL.revokeObjectURL(url);
      })
      .catch((err) => {
        toast.error(
          err?.response?.data?.message ||
            err?.response?.data?.error ||
            "Try again later"
        );
      })
      .finally(() => {
        setExportLoading(false);
      });
  };
  return (
    <div className="card">
      <div className="px-4 py-3 d-flex justify-content-end gap-2 flex-column flex-md-row">
        <div className="flex-fill flex-sm-grow-0">
          <DebounceSmallSearchInput handleSearchChange={handleSearchChange} />
        </div>

        <div className="d-flex flex-wrap gap-2">
          {userRole !== "HOD" && (
            <GlobalSearchableDropdown
              options={departmentOption}
              selected={selectedDepartmet}
              onSelect={setSelecetdDepartment}
              placeholder="Department"
            />
          )}
          <button
            className="btn btn-success d-flex align-items-center gap-1 align-self-center"
            style={{ padding: "0.4rem 0.6rem" }}
            onClick={handleExport}
            disabled={exportLoading}
          >
            {exportLoading ? (
              <Spinner animation="border" size="sm" />
            ) : (
              <FaDownload />
            )}
            Export
          </button>
        </div>
      </div>
      {loading ? (
        <div className="text-center my-4">
          <Spinner animation="border" />
        </div>
      ) : error ? (
        <div className="text-center my-4 text-danger">{error}</div>
      ) : data?.length > 0 ? (
        <div className="table-responsive">
          <table className="table fs-6 mb-0 align-middle">
            <thead className="table-light custom-thead">
              <tr>
                <th>Employee Name</th>
                <th>Email</th>
                {userRole !== "HOD" && <th>Department</th>}
                <th>Number Of Assets</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {data?.map((emp, index) => (
                <tr key={index}>
                  <td>
                    <Link
                      to={`/users/${emp?.id}`}
                      className="fw-bold text-primary"
                    >
                      {emp?.fullname || "-"}
                    </Link>
                  </td>
                  <td>{emp?.email || "-"}</td>
                  {userRole !== "HOD" && <td>{emp?.department || "-"}</td>}
                  <td>{emp?.assets_count || 0}</td>
                  <td>
                    <Link
                      className="btn rounded-2 btn-sm stylish-transparent-btn "
                      style={{ padding: "0.2rem 0.6rem" }}
                      to={`/my-asset/employee-asset-deatails/${emp?.id}`}
                    >
                      View
                      <FaArrowAltCircleRight className="ms-1" size={14} />
                    </Link>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : (
        <div className="text-center my-4">No data found</div>
      )}
      {!loading && data?.length > 0 && (
        <div className="p-4">
          <Pagination
            currentPage={param.page}
            recordsPage={param.page_size}
            dataLength={total}
            handlePagination={handlePageChange}
          />
        </div>
      )}
    </div>
  );
};

export default DepartmentEmployeeAsset;
